module.exports = __webpack_public_path__ + "static/media/vitalChat_2.ce109e9c.png";